import * as React from 'react';
import { TextFormatter } from '../formatters/TextFormatter';

export const Description = (props: { value?: string | JSX.Element | JSX.Element[] }) => {
    return <div className='info-callout-content'>
        {typeof props.value === 'string'
            ? <TextFormatter
                value={(props.value as string).trim()}
                hideTitle={!!props.value}
                isMultiline
                withNavigation
                urlTextMaxLen={50} />
            : <>{props.value}</>
        }</div>;
}
